module.exports = __webpack_public_path__ + "static/img/city_7@2x.a8b2945a.png";